import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import ReactDom from "react-dom";
import PopUpRegistrarse from "../PopUpRegistro/index";
import PopUpRecuperarPassword from "../PopUpRecuperarPassword";
import close from "./iconoPopUpLogin/close.svg";
import { useDispatch, useSelector } from "react-redux";
import {
    setToken,
    setUsuario,
    setConfiguracion,
    setFechasFiltro
} from "../../../../redux/actions/loginAction";
import { seedBackend } from "helpers";
import { Encriptar } from "@renedelangel/helpers";
import * as Consultas from "../../../../Querys/Login/index";
import PopUpAlert from "../PopUpAlerta";
import LoaderLogoSoftwone from "_layout/assets/svg/Animaciones/logoSoftwone";

const { DescriptarToken } = Encriptar;

export default function PopUpLogin(props) {
    let { loginOpen,
        propsSetOpenAlert,
        propsSetAlert,
        propsUseExtModal = false,
        propsSetOpenModal = () => {},
        propsCarritoSelect = null,
        propsSetCarritoTemp
     } = props;

    const dispatch = useDispatch();
    const setTokenRedux = token => {
        dispatch(setToken(token));
    };
    const setUsuarioRedux = usuario => {
        dispatch(setUsuario(usuario));
    };


    /*----------------------------------------------------------------*/
    const [openRegistrarse, setOpenRegistrarse] = useState(false);
    const [openLoginInside, setopenLoginInside] = useState(true);
    const [openRecuperarPassword, setOpenRecuperarPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [datosLogin, setDatosLogin] = useState({
        user: "",
        password: "",
        nombreUsuario: ""
    });
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState({
        titulo: '',
        mensaje: ''
    })
    const userRef = useRef(null);
    const passwordRef = useRef(null);

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    /*----------------------------------------------------------------*/
    function ftVerificaUsername() {
        async function verificaUsername() {
            try {
                const isValid = await Consultas.Ejecutar(
                    { username: datosLogin.username },
                    null,
                    Consultas.IS_USERNAME
                );
                if (!isValid)
                setAlertMessage({
                        titulo: 'Error',
                        mensaje: 'No fue posible válidar al usuario capturado'
                    })
                    setOpenAlert(true);
            } catch ({ message: helperText }) {}
        }
        verificaUsername();
    }

    /*----------------------------------------------------------------*/
    function ftIniciarSesion() {
        async function iniciarSesion() {
            try {
                const token = await Consultas.Ejecutar(
                    {
                        username: datosLogin.user,
                        password: datosLogin.password
                    },
                    datosLogin.token,
                    Consultas.GET_LOGIN
                );
                if (!token){/* alert("No se puede obtener el token"); */
                setLoading(false);
                setAlertMessage({
                    titulo: 'Error',
                    mensaje: 'No se pudo obtener el token, intente acceder nuevamente'
                });
                setOpenAlert(true);
                
            }

                let { usuario } = await DescriptarToken({
                    token,
                    seed: seedBackend
                });

                if(propsUseExtModal){
                    setUsuarioRedux(usuario);
                    setTokenRedux(token);
                    await delay(3000);
                    setLoading(false);
                    loginOpen(false);
                    propsSetOpenModal(true);
                }else if(propsCarritoSelect !== null){
                    setUsuarioRedux(usuario);
                    setTokenRedux(token);
                    await delay(3000);
                    setLoading(false);
                    loginOpen(false);
                    propsSetCarritoTemp(true);
                }
                else{
                propsSetAlert({
                    titulo: '¡Bienvenido!',
                    mensaje: '¡Ha iniciado sesión de forma correcta!'
                });
                propsSetOpenAlert(true);
                setLoading(false);
                setUsuarioRedux(usuario);
                setTokenRedux(token);
                await delay(3000);
                loginOpen(false);
            }

                return;
            
            } catch ({message}) { 
                setLoading(false);
                setAlertMessage({
                titulo: 'Error',
                mensaje: 'No se pudo iniciar sesión, verifique su información'
            });
            setOpenAlert(true);;}
        }
        iniciarSesion();
    }
    /*----------------------------------------------------------------*/

    function registrarse(open) {
        if (open == true) {
            return (
                <>
                    <PopUpRegistrarse
                        loginInside={setopenLoginInside}
                        registrarseState={setOpenRegistrarse}
                        loginPrincipal={loginOpen}
                        propsSetOpenAlert = {propsSetOpenAlert}
                        propsSetAlert = {propsSetAlert}
                    />
                </>
            );
        } else if (open == false) {
            return null;
        }
    }

    function recuperarPassword(open){
        if(open == true){
            return(
                <>
                <PopUpRecuperarPassword
                loginInside={setopenLoginInside}
                loginPrincipal={loginOpen}
                />
                </>
            )
        } else if (open == false){
            return null;
        }
    }

    /*----------------------------------------------------------------*/
    function handleChange(e) {
        const { name, value } = e.target;
        setDatosLogin(prevState => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }

    /*----------------------------------------------------------------*/
    const { user, password } = datosLogin;

    function loginRender(openLoginInside) {
        if (openLoginInside == true) {
            return (
                <div className="contenedorPopUpLogin" onClick={()=>{setopenLoginInside(false);
                    loginOpen(false);}}>
                    <div className="contenedorInternoPopUpLogin"  onClick={(e) =>{e.stopPropagation()}}>
                        <div className="closeLogin">
                            <img
                                onClick={() => {
                                    setopenLoginInside(false);
                                    loginOpen(false);
                                }}
                                src={close}
                            />
                        </div>
                        <h1>INICIA SESIÓN</h1>
                        <div className="contenedorCamposLogin">
                            <input
                                type="input"
                                placeholder="Usuario"
                                name="user"
                                value={user}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                            <input
                                type="password"
                                placeholder="Contraseña"
                                name="password"
                                value={password}
                                onChange={e => {
                                    handleChange(e);
                                }}
                                onKeyDown={(e)=>{if(e.key == 'Enter'){
                                    setLoading(true);
                                    ftIniciarSesion();
                                }}}
                            />
                        </div>
                        <div className='cButtonIniciarSesion'>
                        <button
                            
                            className="iniciarSesion"
                            onClick={()=>{
                                setLoading(true);
                                ftIniciarSesion()}
                            }
                        >
                            Iniciar sesión
                        </button>

                        <button
                            onClick={() => {
                                setOpenRegistrarse(true);
                            }}
                            className="createAccount"
                        >
                            Crear una cuenta
                        </button>

                        <button onClick={() => {setOpenRecuperarPassword(true)}} className="recoverPass" type="password">
                            ¿Olvidaste tu contraseña?
                        </button>
                        </div>
                        
                       
                    </div>
                </div>
            );
        } else if (openLoginInside == false) {
            return <></>;
        }
    }

    return ReactDom.createPortal(
        <>
            <>{registrarse(openRegistrarse)}</>
            <>{loginRender(openLoginInside)}</>
            <>{recuperarPassword(openRecuperarPassword)}</>
            {openAlert? <PopUpAlert titulo={alertMessage.titulo} mensaje={alertMessage.mensaje} open={setOpenAlert}/> : <></>}

            {
                loading ? 
                <LoaderLogoSoftwone/> :
                <></>
            }
        </>,
        document.getElementById("login")
    );
}
